/**
 * The possible active views.
 */
export const Views = {
  Datasets: 'DATASETS',
  Infrastructure: 'INFRASTRUCTURE',
  Export: 'EXPORT'
}
